export default __webpack_public_path__ + "static/media/Apple_logo_black.7e01483f.png";